import React from 'react';

import { ReactComponent as ArrowDown } from '../../../assets/icons/ArrowDown.svg';

import classes from './BackButton.module.scss';

const BackButton = ({ className, onClick }) => {
  const backHandler = () => {
    if (!!onClick) {
      onClick();
    }
  };

  const buttonClassNames = [classes.container];
  if (className) {
    buttonClassNames.push(className);
  }

  return (
    <button className={buttonClassNames.join(' ')} onClick={backHandler}>
      <ArrowDown className={classes.icon} />
      <span className='semibold-14'>Volver</span>
    </button>
  );
};

export default BackButton;
